import "./styles.css";
import CameraDetector from "./Components/CameraDetector";

function App() {
  return (
    <div className="App">
      <h1>Rust Detection with Camera</h1>
      <CameraDetector />
    </div>
  );
}

export default App;
